export default function getCheckoutSlug(checkout) {
  return checkout.slug || checkout._id;
}
